export default function ContactUs() {
  return <h1>ContactUs</h1>;
}
